export const customerKeys = {
    all: ['customers'],
    options: (search = '') => [...customerKeys.all, 'options', search],
    option: (id) => [...customerKeys.all, 'option', id],
    balance: (id) => [...customerKeys.all, 'balance', id],
    detail: (id, params) => [...customerKeys.all, 'detail', id, params],
    // The profile-only form the order page asks for: no balance, no address list.
    profile: (id) => customerKeys.detail(id, { customer_netsuite_id: id, include_balance: 0, addresses: 0 }),
    suggestedAll: () => [...customerKeys.all, 'suggested'],
    suggested: (id, body) => [...customerKeys.suggestedAll(), id, body],
};

export const productKeys = {
    all: ['products'],
    tiers: (id) => [...productKeys.all, 'tiers', Number(id)],
};

export const orderKeys = {
    all: ['orders'],
    status: (id) => [...orderKeys.all, 'status', Number(id)],
};
